/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_HeadingInputs */

const sv_preview_heading = /** @type {(inputs: Preview_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förhandsgranskning`)
};

const en_preview_heading = /** @type {(inputs: Preview_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview mode`)
};

/**
* | output |
* | --- |
* | "Preview mode" |
*
* @param {Preview_HeadingInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const preview_heading = /** @type {((inputs?: Preview_HeadingInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_HeadingInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_preview_heading(inputs)
	return en_preview_heading(inputs)
});